// ============================================================================
// OVERTIME TAX - frontend/src/pages/OvertimeTaxConfiguration.js
// Frozen until the client decides: a read-only view of what payroll applies.
// The editor that was here changed overtime_tax_brackets, which payroll does
// not read.
// ============================================================================

import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import OvertimeTaxFrozen from '../components/OvertimeTaxFrozen';

const OvertimeTaxConfiguration = () => {
  const { t } = useLanguage();
  return (
    <div className="overtime-tax-page">
      <div className="page-head">
        <div>
          <h1 className="page-title">{t('Overtime Tax')}</h1>
          <p className="page-sub">{t('Progressive tax on overtime pay')}</p>
        </div>
      </div>
      <OvertimeTaxFrozen />
    </div>
  );
};

export default OvertimeTaxConfiguration;
